/**
 * Pre-compiled de messages for TagGroup
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { removeTag: `Tag entfernen` };
